import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Learn = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2.23a6.336 6.336 0 1 0 0 12.672A6.336 6.336 0 0 0 22 2.23Zm-8.146 6.336a8.146 8.146 0 1 1 16.293 0 8.146 8.146 0 0 1-16.293 0ZM6.01 15.973v19.053l15.086 7.112v-19.7L6.01 15.974Zm16.896 6.466v19.7l15.086-7.113V15.973L22.906 22.44ZM4.199 15.333a1.388 1.388 0 0 1 1.935-1.276L22 20.857l15.866-6.8a1.388 1.388 0 0 1 1.935 1.276v19.961c0 .538-.31 1.027-.796 1.256l-16.413 7.737a1.388 1.388 0 0 1-1.184 0L4.995 36.55a1.388 1.388 0 0 1-.796-1.256V15.333Z"
  }));
});
Learn.displayName = 'Learn';
Learn.defaultProps = {
  'aria-label': 'Learn'
};
export default Learn;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Learn.js
// module id = 3195
// module chunks = 11